// extracted by mini-css-extract-plugin
module.exports = {"logo":"FullDealEntryPointActions_logo__2eIZt","buttonFullWidth":"FullDealEntryPointActions_buttonFullWidth__SrsYm"};